import React from 'react';

import { sqlDateToLabel, formatAmount, fractionToPercent } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';

import DepositSingleIcon from 'components/Icons/DepositSingleIcon';
import DepositRegularIcon from 'components/Icons/DepositRegularIcon';

import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from '../Targets/TargetsStyle';
import { DepositsData } from 'stores/workflowStores/finances/depositsStore/model';
import { Currency, EdwardColors } from 'enums';

interface Props {
  deposits: DepositsData;
  currency: Currency;
  hideSingleDeposit?: boolean;
  annual?: boolean;
  actualInflation: number;
  original?: boolean;
}

const Deposits = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();
  const { deposits, currency, hideSingleDeposit, annual, actualInflation, original } = props;

  return (
    <>
      <H2>Plánované vklady</H2>
      {!hideSingleDeposit && (
        <Grid container item xs={12} spacing={1}>
          <Grid container item alignContent="center" alignItems="center" className={classes.target}>
            <Grid item xs={1} className={classes.icon}>
              <DepositSingleIcon fontSize="inherit" htmlColor={original ? EdwardColors.GRAY_MEDIUM : undefined} />
            </Grid>
            <Grid item xs={7}>
              <span className={styles.mediumText}>Jednorázový vklad</span>
            </Grid>
            <Grid item xs={2}>
              <span className={styles.mediumText}>{deposits.initial && formatAmount(deposits.initial.value, currency)}</span>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid container item xs={12} spacing={1}>
        <Grid container item alignContent="center" alignItems="center" className={classes.target}>
          <Grid item xs={1} className={classes.icon}>
            <DepositRegularIcon fontSize="inherit" htmlColor={original ? EdwardColors.GRAY_MEDIUM : undefined} />
          </Grid>
          <Grid item xs={7}>
            <span className={styles.mediumText}>Pravidelný vklad</span>
            <br />
            {deposits.periodic && <>měsíčně do {sqlDateToLabel(deposits.periodic.until, 'MM/yyyy')}</>}
            {deposits.periodic?.inflation?.enabled && <> | plánovaná inflace: {fractionToPercent(deposits.periodic.inflation.rate)}</>}
          </Grid>
          <Grid item xs={2}>
            <span className={styles.mediumText}>
              {annual && deposits.periodic?.inflation?.valuation ? (
                <></>
              ) : (
                <span className={`${styles.medium} ${styles.value}`}>{deposits.periodic && formatAmount(deposits.periodic?.value, currency)}</span>
              )}
            </span>
          </Grid>
          {annual && deposits.periodic?.inflation!.valuation && (
            <>
              <Grid item xs={12} className={`${styles.bold} ${styles.regularText}`}>
                Částka vkladu se automaticky navyšuje podle{' '}
                {deposits.periodic?.inflation?.type === 'ACTUAL' ? 'skutečné' : 'nastavené'} inflace{' '}
                {fractionToPercent(deposits.periodic?.inflation?.type === 'PLANNED' ? deposits.periodic?.inflation!.rate : actualInflation)}{' '}
                na <span className={styles.mediumText}>{formatAmount(deposits.periodic?.value, currency)}</span>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Deposits;
